(() => {
  const controllers = new WeakMap();
  function mount(root) {
    const header = root.matches?.('.shopify-section--header') ? root : root.querySelector?.('.shopify-section--header');
    if (!header || controllers.has(header)) return;
    const nav = header.querySelector('.header__main-nav .header__link-list');
    const wrapper = header.querySelector('.header__wrapper');
    if (!nav || !wrapper) return;
    const drawer = document.getElementById('header-sidebar-menu');
    let frame;
    const update = () => {
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(() => {
        if (innerWidth < 1150) { header.classList.remove('bb-header--compact'); drawer?.classList.remove('bb-menu-overflow'); return; }
        const style = getComputedStyle(wrapper);
        const available = wrapper.clientWidth - parseFloat(style.paddingLeft) - parseFloat(style.paddingRight);
        const items = [...nav.querySelector('ul').children];
        const gap = parseFloat(getComputedStyle(nav).columnGap) || 0;
        const required = items.reduce((n, el) => n + el.getBoundingClientRect().width, 0) + gap * Math.max(0, items.length - 1)
          + header.querySelector('.header__logo').getBoundingClientRect().width
          + header.querySelector('.header__secondary-nav').getBoundingClientRect().width
          + (parseFloat(style.columnGap) || 0) * 2;
        header.classList.toggle('bb-header--compact', required > available);
        drawer?.classList.toggle('bb-menu-overflow', required > available);
      });
    };
    const observer = new ResizeObserver(update);
    observer.observe(wrapper);
    observer.observe(nav);
    document.fonts?.ready.then(update);
    controllers.set(header, () => { observer.disconnect(); cancelAnimationFrame(frame); });
    update();
  }
  mount(document);
  document.addEventListener('shopify:section:load', event => mount(event.target));
  document.addEventListener('shopify:section:unload', event => { controllers.get(event.target)?.(); controllers.delete(event.target); });
  document.addEventListener('click', event => {
    if (!event.target.closest('[data-bb-menu-cart]')) return;
    const menu = document.getElementById('header-sidebar-menu');
    if (typeof menu?.hide === 'function') menu.hide();
  });
})();

(() => {
  const counters = new WeakMap();
  function mountCounters(root) {
    const header = root.matches?.('.shopify-section--header') ? root : root.querySelector?.('.shopify-section--header');
    if (!header || counters.has(header)) return;
    const source = header.querySelector('.header__secondary-nav');
    const badges = header.querySelectorAll('[data-bb-menu-count]');
    if (!source || !badges.length) return;
    const selectors = {
      cart: '.header__cart-count cart-count',
      wishlist: '.bb-header-wishlist .th_wlc_product_count'
    };
    const sync = () => {
      badges.forEach(badge => {
        const value = source.querySelector(selectors[badge.dataset.bbMenuCount])?.textContent.trim() || '';
        const count = /^\d+$/.test(value) ? Number(value) : 0;
        const text = count > 0 ? String(count) : '';
        if (badge.textContent !== text) badge.textContent = text;
        badge.hidden = count === 0;
      });
    };
    const observer = new MutationObserver(sync);
    observer.observe(source, { childList: true, characterData: true, subtree: true });
    counters.set(header, observer);
    sync();
  }
  mountCounters(document);
  document.addEventListener('shopify:section:load', event => mountCounters(event.target));
  document.addEventListener('shopify:section:unload', event => {
    counters.get(event.target)?.disconnect();
    counters.delete(event.target);
  });
})();
